import { useEffect, useState } from 'react';

import { useContentLikes } from './useContentLikes';
import { useUserLike } from './useUserLike';

function calcLikeCountDiff(result, likeCount) {
  if (result === false && likeCount === 0) {
    return 0;
  }

  if (result === true) {
    return 1;
  }

  return -1;
}

export const useLikes = ({
  brandSlug,
  contentType,
  id,
  slug,
  utm,
  fingerprint,
  brandId,
  interactionSlug,
}) => {
  const { count, isReady: isContentReady } = useContentLikes({
    brandSlug,
    contentType,
    id,
    slug,
  });
  const { isLiked, isUserReady, toggleLike } = useUserLike({
    id,
    contentType,
    utm,
    fingerprint,
    brandId,
    interactionSlug,
  });
  const [likeCount, setLikeCount] = useState(count);

  useEffect(() => {
    setLikeCount(count);
  }, [count]);

  async function toggle() {
    const result = await toggleLike();

    if (result === null) {
      return null;
    }

    /**
     * If the result is 'true' it is liked, if it is 'false' it is unliked.
     * Based on the result the likecount will increment (true) or decrement (false)
     */
    const diff = calcLikeCountDiff(result, likeCount);
    setLikeCount(likeCount + diff);

    return result;
  }

  return {
    isLikedByUser: isLiked,
    isReady: isContentReady && isUserReady,
    likeCount,
    toggle,
  };
};
